import { getCellTime as e } from "./atoms-v259.js";
function f(r, t) {
  return (e(r) - e(t)) / (1e3 * 3600 * 24);
}
export {
  f as getDifferenceInDays
};
